<div class="nk-header nk-header-fluid is-theme">
  <div class="container-xl wide-xl">
    <div class="nk-header-wrap">
      <div class="nk-menu-trigger me-sm-2 d-lg-none">

        <!-- <a href="#" class="nk-nav-toggle nk-quick-nav-icon" (click)="toggleMenu($event)">
          <em class="icon ni ni-menu"></em>
        </a> -->

      </div>
      <div class="nk-header-brand">
        <a [routerLink]="['/']" class="logo-link">
          <img class="logo-light logo-img" src="assets/images/logo/logo-mdc.svg" alt="logo">
          <img class="logo-dark logo-img" src="assets/images/logo/logo-mdc.svg" alt="logo-dark">
        </a>
      </div>

      <!-- <div class="nk-header-menu" [class.nk-sidebar-active]="menuOpen" #headerMenu>
        <div class="nk-header-mobile">
          <div class="nk-header-brand">
            <a [routerLink]="['/']" class="logo-link">
              <img class="logo-light logo-img" src="assets/images/logo/logo.svg" style="height: 50px;" alt="logo">
              <img class="logo-dark logo-img" src="assets/images/logo/logo.svg" style="height: 50px;" alt="logo-dark">
            </a>
          </div>
          <div class="nk-menu-trigger me-n2">
            <a href="#" class="nk-nav-toggle nk-quick-nav-icon" (click)="toggleMenu($event)">
              <em class="icon ni ni-arrow-left"></em>
            </a>
          </div>
        </div>

        <ul class="nk-menu nk-menu-main">
          <li class="nk-menu-item">
            <a href="#" class="nk-menu-link">
              <span class="nk-menu-text">FAQs</span>
            </a>
          </li>
          <li class="nk-menu-item">
            <a href="#" class="nk-menu-link">
              <span class="nk-menu-text">Offline</span>
            </a>
          </li>
        </ul>
      </div> -->

      <div class="nk-header-tools">
        <ul class="nk-quick-nav">

          <li class="dropdown order-sm-first">
            <div class="user-name" *ngIf="remainingTime">
              {{ prefixMessage + " " + remainingTime }}
            </div>
            <div *ngIf="!remainingTime" class="user-name">
              {{'dateEndAlertSimple'|translate}}
            </div>
          </li>

          <li *ngIf="!authService.isAuthenticated() && isNotWeb()" class="dropdown">
            <a [routerLink]="['/login']" class="nk-quick-nav-icon">
              <em class="icon ni ni-user-fill-c"></em>
            </a>
          </li>

          <li *ngIf="authService.isAuthenticated()" class="dropdown user-dropdown order-sm-first">
            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown">
              <div class="user-toggle">
                <div class="user-avatar sm">
                  <em class="icon ni ni-user-alt"></em>
                </div>
                <div class="user-info d-none d-xl-block">
                  <div class="user-name dropdown-indicator">{{authService.getDisplayName()}}</div>
                </div>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-md dropdown-menu-end dropdown-menu-s1 is-light">
              <div class="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                <div class="user-card">
                  <div class="user-avatar">
                    <span>{{authService.getFirtLetter()}}</span>
                  </div>
                  <div class="user-info">
                    <span class="lead-text">{{authService.getFullName()}}</span>
                    <span class="sub-text">{{authService.getEmail()}}</span>
                  </div>
                </div>
              </div>
              <div class="dropdown-inner">
                <ul class="link-list">
                   <li *ngIf="authService.hasRoles(['ADMIN','MANAGER'])"><a [routerLink]="['/dashboard']"><em class="icon ni ni-dashboard"></em><span>Dashboard
                      </span></a></li>
                  <li><a [routerLink]="['/form-offline']"><em class="icon ni ni-download"></em><span>Formulários Offline</span></a></li>                 
                  <li>
                </ul>
              </div>
              <div class="dropdown-inner">
                <ul class="link-list">
                  <li><a href="javascript:void(0)" (click)="logout()"><em class="icon ni ni-signout"></em><span>Terminar
                        Sessão</span></a></li>
                </ul>
              </div>
            </div>
          </li>

          <li *ngIf="showHeader" class="dropdown language-dropdown" (click)="toggleLanguageDropdown()">
            <a class="dropdown-toggle nk-quick-nav-icon pointer"
              [ngClass]="{ 'show': languageService.languageDropdownOpen }"
              [attr.aria-expanded]="languageService.languageDropdownOpen ? 'true' : 'false'" data-bs-toggle="dropdown">

              <div class="quick-icon border border-light">
                <img class="icon" [src]="'assets/images/flags/' + getLanguageFlag(lang)" alt="">
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-end dropdown-menu-s1"
              [ngClass]="{ 'show': languageService.languageDropdownOpen }">
              <ul class="language-list">
                <li *ngFor="let language of languages">
                  <a class="language-item pointer" (click)="changeLanguage(language.code)">
                    <img src="assets/images/flags/{{ language.flag }}" alt="" class="language-flag">
                    <span class="language-name">{{ language.name }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li *ngIf="authService.isAuthenticated()" class="hide-mb-sm">
            <a href="javascript:void(0)" (click)="logout()" class="nk-quick-nav-icon">
              <em class="icon ni ni-signout"></em>
            </a>
          </li>

        </ul>
      </div>
    </div>
  </div>
</div>